import { HourGlassIcon, ProcessingCardContent } from '@components/ProductList/styles';
import { faHourglass } from '@fortawesome/pro-light-svg-icons';
import { Job } from '@providers/job/types';
import { useTranslation } from 'react-i18next';

export default function ProcessingCard({ job, redirectURL }: Readonly<{ job: Job; redirectURL: string }>) {
  const { t } = useTranslation('productLibrary');

  const { jobType, status, productName } = job;

  if (jobType === 'CAD') {
    return (
      <ProccessCard
        redirectURL={redirectURL}
        header={t('fileIsBeingProcessed', { productName })}
        subHeader={t('pleaseComeBackSoon')}
        status={status}
      />
    );
  }

  /* istanbul ignore next */
  return null; // filtering above should prevent getting here...
}

interface ProcessingCardProps {
  redirectURL: string;
  header: string;
  subHeader: string;
  status: string;
}

function ProccessCard({ redirectURL, header, subHeader, status }: Readonly<ProcessingCardProps>) {
  return (
    <ProcessingCardContent to={redirectURL} data-testid={`processing-${status}`}>
      <HourGlassIcon icon={faHourglass} size="5x" />
      <h3>{header}</h3>
      <h4>{subHeader}</h4>
    </ProcessingCardContent>
  );
}
